<!--
    描述：组织机构-人员列表
    日期：2021/04/22
    作者：zwh
-->
<template>
    <div class="h100">
        <div class="w-table-layout">
            <div class="w-table-content" ref="usersContent">
                <el-table v-loading="tableObj.loading" :data="tableObj.data" :border="true"
                          :height="tableObj.tableH" ref="softWareTable" highlight-current-row>
                    <el-table-column type="index" align="center" width="50"></el-table-column>
                    <el-table-column
                                     align="center"
                                     width="55">
                        <template slot="header" slot-scope="scope">
                            <div></div>
                        </template>
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.isChecked" @change="handleCheck($event, scope.row)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column prop="sname" header-align="center" label="姓名" show-overflow-tooltip
                        min-width="120"></el-table-column>
                    <el-table-column prop="username" header-align="center" label="用户名" show-overflow-tooltip
                        min-width="120"></el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
//import { getAuditNoPageList } from 'api/modules/approval/in_flo'
export default {
    name : '',
    components: {

    },
    data() {
        return {
            deptId : '',
            tableObj : {
                loading : false,
                data : [],
                tableH : 500,
            },
            //选中list
            checkedList : [],
        }
    },
    mounted() {},
    computed: {},
    watch: {},
    created() {},
    methods: {
        //获取列表信息
        getTableList(deptObj){
            this.tableObj.data = []
            this.deptId = deptObj.id
            this.tableObj.data = deptObj.users
        },
        // 数据权限复选框 check 事件
        handleCheck(status, row) {
            /*
            let _item = this.checkedList.find(x => x.id === row.id)

            if (_item) {
                _item.isChecked = status
            }
            */
            row.isChecked = status
            this.$emit("user-trans-data", this.deptId, row)
        },
    }
}
</script>
<style lang="less">

</style>